<script setup lang="ts">
import { computed } from 'vue'
import BaseBanner from './base/BaseBanner.vue'
import type { LiveOpsLeaderboard } from '@/types/live-ops'
import { liveOpsEventTemplates } from '@/composables/game/live-ops-events'

const props = withDefaults(defineProps<{
  pulsate?: boolean
  leaderboard: LiveOpsLeaderboard
}>(), {
  pulsate: false,
})

const template = computed(() =>
  liveOpsEventTemplates.value.find(
    t => t.id === props.leaderboard.mainEventTemplateId,
  ) ?? null,
)

const leaderboardName = computed(() => props.leaderboard.name)
const mainColor = computed(() => props.leaderboard.mainColor ?? template.value?.mainColor ?? '#635BFF')
const mainIconUrl = computed(() => props.leaderboard.mainIconUrl ?? template.value?.mainIconUrl ?? '')
</script>

<template>
  <BaseBanner
    :pulsate="pulsate"
    show-live-chip
  >
    <div
      class="flex items-center justify-center w-full h-full relative overflow-hidden"
      :style="{ background: `linear-gradient(180deg, ${mainColor} 14.03%, ${mainColor} 50.68%, #000 107.81%)` }"
    >
      <img
        v-if="mainIconUrl"
        class="absolute left-0 h-full object-contain"
        :src="mainIconUrl"
        alt=""
      >
      <img
        v-if="mainIconUrl"
        class="absolute right-0 h-full object-contain"
        :src="mainIconUrl"
        :style="{ transform: 'scaleX(-1)' }"
        alt=""
      >
      <h2 class="font-pilat font-black text-[28px] leading-7 text-white text-center relative z-[1] max-w-[200px]">
        {{ leaderboardName }}
      </h2>
    </div>
  </BaseBanner>
</template>
